import CreateNewToolButton from '../CreateNewToolButton/CreateNewToolButton';
import './ToolSearchDefault.scss';

interface IToolSearchDefault {
  onCreateNew: () => void;
}

/**
 * Sección por defecto cuando no hay búsqueda activa.
 * Ofrece crear la herramienta directamente en catálogo.
 */
const ToolSearchDefault = ({ onCreateNew }: IToolSearchDefault) => (
  <div className="toolSearchDefault">
    <div className="createLabel">O crea la herramienta en catálogo</div>
    <CreateNewToolButton onClick={onCreateNew} />
  </div>
);

export default ToolSearchDefault;
